import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

import Breadcrumbs from "~/components/mobile/Breadcrumbs";
import InventoryBottomNav from "~/components/mobile/InventoryBottomNav";
import OfflineBanner from "~/components/mobile/OfflineBanner";
import SyncStatusBanner from "~/components/mobile/SyncStatusBanner";
import usePageTitle from "~/hooks/usePageTitle";
import MobilePageLayout from "~/layout/mobile/MobilePageLayout";

/**
 * Shell wrapper for every mobile feature area. Provides the persistent chrome — offline/sync status
 * banners and breadcrumbs in the header, module bottom navigation in the footer — and renders the
 * active feature area through the router Outlet. Feature slices supply their own page content and
 * may compose their own MobilePageLayout for in-page headers/footers.
 */
const MobileLayout = () => {
	usePageTitle();

	return (
		<MobilePageLayout
			header={
				<Box>
					<OfflineBanner />
					<SyncStatusBanner />
					<Breadcrumbs />
				</Box>
			}
			mobileNav={<InventoryBottomNav />}
		>
			<Outlet />
		</MobilePageLayout>
	);
};

export default MobileLayout;
